module.exports = __webpack_public_path__ + "img/SG.8e93f7bd.svg";